import axios from 'axios'

export default {
    namespaced: true,

    state: {
        application: {},
        applicationGrade: {},
        applicationSubjectChoice: {},
        applicationExisting: {},
        authenticated: sessionStorage.authenticated || false,
        schoolName: process.env.VUE_APP_THEME_SCHOOL,
        applicationDelete: {},
        applicationYear: null,
        applicationsLockStatus: 0,
    },

    getters: {
        getApplication (state) {
            return state.application
        },

        getApplicationGrade (state) {
            return state.applicationGrade
        },

        getApplicationSubjectChoice (state) {
            return state.applicationSubjectChoice
        },

        getApplicationExisting (state) {
            return state.applicationExisting
        },

        getAuthenticated (state) {
            return state.authenticated
        },

        getSchoolName (state) {
            return state.schoolName
        },

        getApplicationDelete (state) {
            return state.applicationDelete
        },

        getApplicationYear (state) {
            return state.applicationYear
        },

        getApplicationsLockStatus (state) {
            return state.applicationsLockStatus
        },
       
    },

    mutations: {
        setApplication (state, value) {
            state.application = value
        },

        setApplicationGrade (state, value) {
            state.applicationGrade = value
        },

        setApplicationSubjectChoice (state, value) {
            state.applicationSubjectChoice = value
        },

        setApplicationExisting (state, value) {
            state.applicationExisting = value
        },

        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setApplicationDelete (state, value) {
            state.applicationDelete = value
        },

        setApplicationYear (state, value) {
            state.applicationYear = value
        },

        setApplicationsLockStatus (state, value) {
            state.applicationsLockStatus = value
        }
    },

    actions: {
        getCSRFCookie () {
            return axios.get('/sanctum/csrf-cookie');
        },

        postApplication ({ getters }){
            const url = '/api/csec-subject-choices-application';
            let application = getters.getApplication || {};
            return axios.post(url, application);
        },
        
        postApplicationSubjectChoice ({ getters }) {
            const url = '/api/csec-subject-choices-application-subject-choice';
            return axios.post(url, getters.getApplicationSubjectChoice);
        },


        getApplication (context ,student_id) {
            const url = "/api/csec-subject-choices-application";
            return axios.get(url, {
                params: {
                    student_id: student_id,
                }
            });
        },

        getApplicationSubjectChoices ({ getters}) {
            const url = "/api/csec-subject-choices-application-subject-choices";
            return axios.get(url, {
                params: {
                    student_id: getters.getApplication.student_id,
                }
            });
        },

        getSubjectLines () {
            const url = "/api/csec-subject-choices-application-subject-lines";
            return axios.get(url);
        },
      

        adminSignIn ({ getters }) {
            return axios.post('/api/admin-login', {
                name: getters.getApplicationExisting.name,
                password: getters.getApplicationExisting.password
            })
        },

        getAllApplications () {
            const url = "/api/sixth-form-applications";
            return axios.get(url);
        },

        deleteApplication ({ getters }) {
            const url = "/api/sixth-form-application";
            return axios.delete(url, { data: getters.getApplicationDelete});
        },

        downloadAcceptedSpreadsheet ({ getters }) {
            const url = "/api/sixth-form-application-accepted-excel/" + getters.getApplicationYear;
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            });
        },

        adminSignOut () {
            return axios.post('/logout');
        },

        getInstructionsURL () {
            const url = "/api/sixth-form-application-instructions";
            return axios.get(url);
        },

        getApplicationsLockStatus ({ getters }) {
            const url = "/api/sixth-form-application-lock-status/" + getters.getApplicationYear;
            return axios.get(url);
        },

        postApplicationsLockStatus({ getters }) {
            const url = "/api/sixth-form-application-lock-status";
            return axios.post(url, {
                locked: getters.getApplicationsLockStatus,
                year: getters.getApplicationYear
            })
        },

        getPrerequisitesURL () {
            const url = "/api/sixth-form-application-prerequisites";
            return axios.get(url);
        },

        getApplicationPeriods () {
            const url = "/api/sixth-form-application-periods";
            return axios.get(url);
        },

        getCurrentApplicationPeriod () {
            const url = "/api/sixth-form-application-current-period";
            return axios.get(url);
        },

        downloadApplicationsSpreadsheet ({ getters }) {
            const url = "/api/sixth-form-applications-all/" + getters.getApplicationYear;
            console.log(url);
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            });
        },

        getApplicationStatus () {
            const url = "/api/sixth-form-applications-status-list";
            return axios.get(url);
        },

        getWaitingListSpreadsheet ({ getters }) {
            const url = "/api/sixth-form-applications-waiting-list/" + getters.getApplicationYear;
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            });
        },

        getToCallListSpreadsheet ({ getters }) {
            const url = "/api/sixth-form-applications-to-call-list/" + getters.getApplicationYear;
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            });
        }
    }
}